import Repository from "@/plugins/axios";

export default {
  // Получить контент страницы "О нас"
  getAbout() {
    return Repository.get("/about");
  },
};
